import React, { Component } from 'react';
import { Text, View, Image, ScrollView, Dimensions, Platform, TextInput } from 'react-native';
import { postSingle, Flex, Padding, Margin, Helpers, aboutAuthor, pageContent, FontFamily, FontWeight, Colors, article, Typo } from '../../styles/appStyles';
import TouchableOpacityLink from '../touchable-opacity-link';
import TouchableOpacityLinkExternal from '../touchable-opacity-link-external';
import CustomImage from '../custom-image';
import getImagePath from '../../utils/image-helper';
import { helpers } from '../../utils/helpers';
import ButtonGradient from '../button-gradient';
import PageBreak from '../page-break';

const StoryRead = getImagePath('img/story-read.png');

export class ShortReads extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount = () => {
    }


    render() {
        let webView = helpers.isWeb();
        return (
            <>
                <View style={{position: 'relative'}}>
                    <View style={{backgroundColor: '#FAFAFA', position: 'absolute', width: '100%', height: helpers.isDesktop() ? 700 : 485, left: 0 , right: 0, top: helpers.isDesktop() ? -200 : -125 }} />
                </View>
                <View style={[Margin.mb_5, Margin.mb_5, Helpers.textCenter, Helpers.conatinerWeb, helpers.isDesktop() && Helpers.conatinerWeb1200, { marginTop: helpers.isDesktop() ? 80 : 75, paddingHorizontal: 20, width: helpers.isDesktop() ? '85%' : '100%'}]}>
                    <View>
                        <View style={[article.headerWrapper, Padding.pb_2]}>
                            <View style={[Flex.alignCenter]}>
                                <View style={[Padding.ph_2, Helpers.titleBgWrap, {backgroundColor: '#fafafa'}]}>
                                    <View style={[Helpers.borderBottom]}>
                                        <Text style={[Helpers.textCenter,Typo.h3_R, helpers.isDesktop() && Typo.h3_RDesktop, Margin.mb_0, {fontSize: 24},{fontFamily:FontFamily.abrilFatface}, {fontSize: helpers.isDesktop() ? 34 : 20} ]}>Short reads</Text>
                                    </View>
                                </View>
                                <View style={[Helpers.titleLine]}></View>
                            </View>                
                        </View>
                    </View>
                    <Text style={{fontFamily:FontFamily.regular, fontSize: helpers.isDesktop() ? 18 : 16, lineHeight: 27, color: '#000000', textAlign: 'center', marginBottom: helpers.isDesktop() ? 24 : 0, letterSpacing: 0.3 }}>Perspective on the big events. Short and timely. News and commentary.</Text>
                    <View style={[Helpers.conatinerWeb, helpers.isDesktop() && Helpers.conatinerWeb800]}>
                          <CustomImage
                            source={StoryRead}
                            require={true}
                            style={{ width: '100%', height: 'auto', resizeMode: 'contain' }}
                            webStyle={{ width: '100%', height: 'auto', objectFit: 'contain' }}
                            altText={'Short reads'}
                        />
                    </View>
                </View>
            </>
        );
    }
}

export default ShortReads;